webpackJsonp([173911521112049],{

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReportTypesGridModule = __webpack_require__(661);
	
	var _ReportTypesGridModule2 = _interopRequireDefault(_ReportTypesGridModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _Animations.ScrollOverPack,
	        _extends({}, props, {
	            className: (props.className ? props.className + ' ' : '') + 'src-components----ReportTypesGrid-module---report-types-grid---1AH0f'
	        }),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: '0', component: _reactstrap.Container }, _Animations.FadeIn),
	            _react2.default.createElement(
	                'div',
	                { className: 'h2' },
	                'Building a data-driving supply chain?'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'h2 text-blue' },
	                'Look no further.'
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: '1', component: _reactstrap.Container }, _Animations.FadeUp),
	            _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Shipment details'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Pull package-level data for your shipments across all of your carriers, instantly. Never touch a slow, clunky carrier web portal again.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Accessorials'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'See which surcharges and accessorials are costing you the most money, and find new opportunities to save.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Time-in-transit'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'View time-in-transit information across countries, states, and zip code prefixes. Want to know how many shipments are missing their deadlines? No longer a problem.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Unit costs'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Manage unit costs across zones, service types, and weights over time. Instantly know which lanes are working and which ones are costing you.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Volume'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Your volumes speak volumes about the health of your business. Pull aggregated volume data by zone, weight, service type, account number, and more.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Audit reports'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Track refund credits that get applied to your carrier accounts over time. View refunds from both Galleon\'s audit, as well as your own internal audit operations.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Invoice summaries'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Get the original, adjusted, and final costs for invoices across all of your carriers. Great for accounting teams.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'Scheduled reports'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Generate any of these reports either weekly or monthly, and have the results emailed to anyone on your team.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----ReportTypesGrid-module---cell---3RBWE' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportTypesGrid-module---heading---2Gs_r' },
	                        'And much more'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'We\'re constantly adding more sophisticated reports. If there\'s something you\'d like to see, just ',
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/contact' },
	                            'let us know'
	                        ),
	                        ' and we\'ll get it added.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"report-types-grid":"src-components----ReportTypesGrid-module---report-types-grid---1AH0f","cell":"src-components----ReportTypesGrid-module---cell---3RBWE","heading":"src-components----ReportTypesGrid-module---heading---2Gs_r"};

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReportingUseCasesSectionModule = __webpack_require__(662);
	
	var _ReportingUseCasesSectionModule2 = _interopRequireDefault(_ReportingUseCasesSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----ReportingUseCasesSection-module---reporting-use-cases-section---3Khnf' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----ReportingUseCasesSection-module---text-container---2z7tL' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Use great data'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Get great results.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----ReportingUseCasesSection-module---message---2dRJk' },
	                    'Here are some examples of how high-performance shipping teams use Galleon reports.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----ReportingUseCasesSection-module---features-table---2nhNH' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportingUseCasesSection-module---feature-row---3mjp3' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----ReportingUseCasesSection-module---heading---2cIxE' },
	                            'Carrier communication'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Seeing too many deliveries arriving late? Download a time-in-transit summary and fire it off to your rep for an explanation.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportingUseCasesSection-module---feature-row---3mjp3' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----ReportingUseCasesSection-module---heading---2cIxE' },
	                            'Customer service'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Want to get ahead of customer complaints? Tee up a daily scheduled report to show you all late and almost-late shipments.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----ReportingUseCasesSection-module---feature-row---3mjp3' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----ReportingUseCasesSection-module---heading---2cIxE' },
	                            'Accounting'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Finance team sick of manually entering invoice totals? Use an invoice summary CSV for a Quickbooks import instead.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-components----ReportingUseCasesSection-module---splash-image-container---3YVjf' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default],
	                className: 'src-components----ReportingUseCasesSection-module---splash-image---2oTjJ'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"reporting-use-cases-section":"src-components----ReportingUseCasesSection-module---reporting-use-cases-section---3Khnf","text-container":"src-components----ReportingUseCasesSection-module---text-container---2z7tL","message":"src-components----ReportingUseCasesSection-module---message---2dRJk","features-table":"src-components----ReportingUseCasesSection-module---features-table---2nhNH","feature-row":"src-components----ReportingUseCasesSection-module---feature-row---3mjp3","heading":"src-components----ReportingUseCasesSection-module---heading---2cIxE","splash-image-container":"src-components----ReportingUseCasesSection-module---splash-image-container---3YVjf","splash-image":"src-components----ReportingUseCasesSection-module---splash-image---2oTjJ"};

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-reporting.fbc7e895.png";

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-reporting@2x.c59fb600.png";

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-reporting@3x.3b3eb1d2.png";

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _ReportTypesGrid = __webpack_require__(371);
	
	var _ReportTypesGrid2 = _interopRequireDefault(_ReportTypesGrid);
	
	var _ReportingUseCasesSection = __webpack_require__(372);
	
	var _ReportingUseCasesSection2 = _interopRequireDefault(_ReportingUseCasesSection);
	
	var _UptimeSplash = __webpack_require__(92);
	
	var _UptimeSplash2 = _interopRequireDefault(_UptimeSplash);
	
	var _imgIphoneReporting = __webpack_require__(792);
	
	var _imgIphoneReporting2 = _interopRequireDefault(_imgIphoneReporting);
	
	var _imgIphoneReporting2x = __webpack_require__(793);
	
	var _imgIphoneReporting2x2 = _interopRequireDefault(_imgIphoneReporting2x);
	
	var _imgIphoneReporting3x = __webpack_require__(794);
	
	var _imgIphoneReporting3x2 = _interopRequireDefault(_imgIphoneReporting3x);
	
	var _iconReporting = __webpack_require__(241);
	
	var _iconReporting2 = _interopRequireDefault(_iconReporting);
	
	var _iconReporting2x = __webpack_require__(242);
	
	var _iconReporting2x2 = _interopRequireDefault(_iconReporting2x);
	
	var _iconReporting3x = __webpack_require__(243);
	
	var _iconReporting3x2 = _interopRequireDefault(_iconReporting3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconReporting2.default, _iconReporting2x2.default, _iconReporting3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'Reporting'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'All the data you need, right at your fingertips.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'Galleon comes ready with dozens of pre-built reports. Not finding what you need? Our team of data engineers is on call to build additional custom reports, on-demand.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-pages-features----dashboard-module---button---3mu4_', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgIphoneReporting2.default, _imgIphoneReporting2x2.default, _imgIphoneReporting3x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_ReportTypesGrid2.default, null),
	        _react2.default.createElement(_ReportingUseCasesSection2.default, null),
	        _react2.default.createElement(_UptimeSplash2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-reporting-js-08f5497950434816fb8a.js